import { Injectable, OnInit } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { HttpService } from "../http.service";
import { APIEndpoints } from "../../../config/apiEndpoint.config";
import { TriggerInitialLoadDTO } from "../Models/write/TriggerInitialLoadDTO";

@Injectable({
  providedIn: "root",
})
export class AdminPanelTriggerInitialLoadService {
  headers: HttpHeaders;
  areaId: string;

  constructor(
    private httpService: HttpService,
    private _httpClient: HttpClient
  ) {
    this.headers = new HttpHeaders();
    this.headers.set("Content-Type", "application/json");
  }

  async triggerInitialLoad(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const data = await new Promise<string>((res) => {
      reader.onload = () => {
        res((reader.result as string).split(",")[1]);
      };
    });

    const dto = {
      fileName: file.name,
      blobData: data,
      mimeType: "application/xml",
    };

    return await this.httpService
      .post(APIEndpoints.uploadInitialLoadBlobFile, dto, true)
      .toPromise();
  }
}
